import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_deleteCmsTranslation, decodeResponse204, Response204Type } from 'src/api_openapi/generated/openapi_website_cms_deleteCmsTranslation';

export type CmsTranslationFormModelType = Response204Type;

const decode = (status: number, data: ResponseType): CmsTranslationFormModelType => {
    if (status === 204 && data.type === 'text') {
        return decodeResponse204(data.text);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface CmsTranslationFormSubmitType {
    id: number;
}

export const deleteCmsTranslation = {
    browser: {
        params: (params: CmsTranslationFormSubmitType): ParamsFetchType<CmsTranslationFormSubmitType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/delete-cms-translation',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/delete-cms-translation',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<CmsTranslationFormSubmitType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const response = await openapi_website_cms_deleteCmsTranslation(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            id: params.req.body.id
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
